import { SelectDropdownItem } from '../interfaces';

export enum PromoType {
  DirectLink = 'direct_link',
  EventLanding = 'event_landing',
  Landing = 'landing',
  PreLanding = 'pre_landing',
  PromoDirectLink = 'promo_direct_link',
}

export const promoTypeRecord: Record<PromoType, string> = {
  [PromoType.DirectLink]: 'Direct Link',
  [PromoType.EventLanding]: 'Event Landing',
  [PromoType.Landing]: 'Landing',
  [PromoType.PreLanding]: 'Pre-Landing',
  [PromoType.PromoDirectLink]: 'Promo Direct Link',
};

export const PROMO_TYPE_SELECT_ITEMS: SelectDropdownItem<PromoType>[] = Object.entries(
  promoTypeRecord,
).reduce<SelectDropdownItem<PromoType>[]>((acc, [value, label]) => {
  if (value !== PromoType.DirectLink) {
    acc.push({ label, value: value as PromoType });
  }

  return acc;
}, []);
